import i18next from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import Languages from './languages'

const DEFAULT_LANGUAGE = 'en'
export const DEFAULT_NAMESPACE = 'common'

const i18n = {
  init: () =>
    i18next
      .use(Backend)
      .use(initReactI18next)
      .init({
        lng: DEFAULT_LANGUAGE,
        fallbackLng: Object.values(Languages),
        fallbackNS: DEFAULT_NAMESPACE,
        defaultNS: DEFAULT_NAMESPACE,
        interpolation: {
          escapeValue: false,
        },
        backend: {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
      }),
}

export default i18n
